<clx-row type="buttons">
    <clx-button type="default" i18n="@@m2mrouter.details.button.back" test-id="administration.m2m.button.back" routerLink="/Administration/M2MRouter">Back</clx-button>
</clx-row>
<div *ngIf="details">
    <div class="summary-container">
        <span class="summary">
            <span class="topic" i18n="@@m2mrouter.detail.summary.iccid">ICCID:</span>
            <span test-id="administration.m2m.text.iccid">{{deviceId}}</span>
        </span>
    </div>
    <table class="clx-table" test-id="administration.m2m.container.detailstable">
        <thead>
            <th i18n="@@m2mrouter.detail.header.name" class="table-label">Name</th>
            <th i18n="@@m2mrouter.detail.header.value">Value</th>
        </thead>
        <tbody class="with-borders">
            <tr>
                <td has="important-text" i18n="@@m2mrouter.detail.imsi">IMSI</td>
                <td [title]="details.deviceId" test-id="administration.m2m.text.imsi">{{details.deviceId}}</td>
            </tr>
            <tr>
                <td has="important-text" i18n="@@m2mrouter.detail.contractnumber">Contract number</td>
                <td [title]="details.contractNumber" test-id="administration.m2m.text.contractnumber">{{details.contractNumber}}</td>
            </tr>
            <tr>
                <td has="important-text" i18n="@@m2mrouter.detail.additionalinformation">Additional information</td>
                <td [title]="details.additionalInformation" test-id="administration.m2m.text.additionalinformation">{{details.additionalInformation}}</td>
            </tr>
            <tr>
                <td has="important-text" i18n="@@m2mrouter.detail.state">State</td>
                <td [title]="details.state" test-id="administration.m2m.text.state">{{details.state | translateM2MDeviceState}}</td>
            </tr>
            <tr>
                <td has="important-text" i18n="@@m2mrouter.detail.assignedtoplantname">Assigned to plant</td>
                <td [title]="details.assignedToPlantName" test-id="administration.m2m.text.assignedtoplant">{{details.assignedToPlantName}}</td>
            </tr>
            <tr>
                <td has="important-text" i18n="@@m2mrouter.detail.serviceprofile">Service profile</td>
                <td [title]="details.serviceProfile" test-id="administration.m2m.text.serviceprofile">{{details.serviceProfile}}</td>
            </tr>
            <tr *ngFor="let item of details.informationItems | excludeInformationItems:['iccid']">
                <td has="important-text">{{item.name | translateM2MInformationItemName}}</td>
                <td [title]="item.value" [attr.test-id]="'administration.m2m.value.' + item.name">{{item.value | formatM2MInformationItemValue:item.type:item.name | async}}</td>
            </tr>
        </tbody>
    </table>
</div>